<template>
    <div class="cookie-block" v-show="show">
        <div class="container">
            <div class="inner">
                <div class="text">
                    <h6>Cookie Policy</h6>
                    <p>This website uses cookies. By continuing to use this site, you accept our use of cookies.</p>
                </div>
                <a href="javascript:void(0)" @click="accept" class="button">accept & close</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            url: String,
        },
        data(){
            return {
                show: true,
            }
        },
        methods: {
            accept(){
                axios.post(this.url)
                    .then(response => {
                        this.show = false;

                        this.$swal.fire({
                            icon: 'success',
                            title: `Success!`,
                            text: 'Thank you!',
                        });
                    })
                    .catch(error => {
                        toastr.error(error);
                    });
            }
        }
    }
</script>
